"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultWranggleBackendApiBaseUrl = void 0;
exports.DefaultWranggleBackendApiBaseUrl = `https://api.wranggle.com`;
//# sourceMappingURL=wranggle-base-url-default.js.map